import React, { useState, useEffect, useMemo } from 'react';
import _ from 'lodash';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { Typography } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { classNames } from '../../../../utils';
import CkeckBox from '../inputs/CkeckBox';
import { systemAPI } from '../../../../apis';
import { userRoleFunc, userRoleList } from '../../../../utils/userRole';
import { roleWeight } from '../../../../comm/RoleMap';
import { i18n } from '../../../../language';
import { permissionFunc, PermissionListFunc, userPermissionFunc } from './RoleEditFrom';

const useStyles = makeStyles({
  root: {
    // minHeight: '22rem',
    overflow: 'auto',
    padding: '0 2.876rem 1.563rem',
    backgroundColor: '#fff',
  },
  tableBody: {},
  table: {
    position: 'relative',
    minWidth: '35rem',
    '& .MuiTableCell-root': {
      border: 'none',
      fontSize: '1rem',
      fontWeight: '500',
      lineHeight: '1.675rem',
      color: '#2e4469',
      padding: '0.813rem 0',
    },
    '& .MuiTableHead-root': {
      position: 'sticky',
      top: '0',
      left: '0',
      zIndex: '10',
      '& .MuiTableRow-root': {
        backgroundColor: '#fff',
      },
      '& .MuiTableCell-root': {
        fontWeight: 'bold',
        color: '#538fff',
        backgroundColor: '#fff',
        textTransform: 'uppercase',
        paddingTop: '0px',
        paddingLeft: '0px',
        paddingRight: '0px',
      },
    },
    '& .MuiTableBody-root': {
      '& > .MuiTableRow-root': {
        borderBottom: '1px solid #E6E8E9',
      },
      '& .MuiTableCell-root': {
        height: '3.5rem',
        fontFamily: 'NotoSans-Medium',
      },
    },
  },
  status: {
    width: '0.625rem',
    height: '0.625rem',
    display: 'inline-block',
    backgroundColor: '#ff655c',
    borderRadius: '50%',
    marginRight: '0.563rem',
  },
  editBtn: {
    width: '2.25rem',
    height: '2.25rem',
    minWidth: '0',
    backgroundColor: '#4c93ff',
    borderRadius: '0.625rem',
    color: '#fff',
    '&:hover': {
      background: '#4c93ff !important',
    },
  },
  editIcon: {
    fontSize: '1rem',
    '&:hover': {
      background: '#4c93ff !important',
    },
  },
  tableHead: {
    whiteSpace: 'nowrap',
  },
  underLine: {
    borderBottom: '1px solid #E6E8E9 !important',
  },
});

export default function RoleEdit({ className, aligns, allData, updateInputValue }) {
  const [PermissionList, setPermissionList] = useState(null);
  const userRole = useSelector((state) => state.userRole);
  const loginInfo = useSelector((state) => state.loginInfo);
  const getSysRoleTypeDetail = async () => {
    try {
      const { result } = await systemAPI.getSysRoleTypeDetail({
        roleTypeId: userPermissionFunc.getRoleTypeId(allData),
      });
      setPermissionList(result);
    } catch (error) {
      console.log('-----RoleEdit getSysPermissionList-----', error);
    }
  };

  const [userPermissionIds, setUserPermissionIds] = useState(userPermissionFunc.getActionIds(allData));
  const isPermissionList = useMemo(() => {
    if (PermissionList && Array.isArray(userPermissionIds)) {
      return PermissionListFunc.isPermissionList(PermissionListFunc.orderAllActions(PermissionList), userPermissionIds);
    }
  }, [userPermissionIds, PermissionList]);

  const onCheckBox = (id) => {
    return (isValue) => {
      let temp = null;
      if (isValue) {
        temp = [...userPermissionIds, id];
      } else {
        temp = userPermissionIds.filter((permissionId) => {
          return permissionId !== id;
        });
      }
      updateInputValue(temp);
      setUserPermissionIds(temp);
    };
  };

  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  useEffect(() => {
    (async () => {
      await getSysRoleTypeDetail();
    })();
    setIsSuperAdmin(
      userRoleFunc.isSuperAdmin(allData) ||
        roleWeight[userRoleFunc.getRoleType(allData)] >=
          roleWeight[userRoleList.getRoleType(userRole, loginInfo.hospitalId, loginInfo.wardId, loginInfo.userId)]
    );
  }, []);

  const classes = useStyles();

  return (
    <TableContainer className={classNames(className, classes.root)}>
      <Table className={classes.table} aria-label="simple table" stickyHeader>
        <TableHead className={classes.tableHead} id="setting_table_head">
          <TableRow>
            {[i18n.t('SETTING_FUNCTION'), i18n.t('SETTING_AVAILABILITY')].map((item, index) => {
              return (
                <TableCell align={aligns[index]} key={item}>
                  {item}
                </TableCell>
              );
            })}
          </TableRow>
        </TableHead>
        <TableBody className={classes.tableBody} id="setting_table_body">
          {_.map(PermissionListFunc.orderAllSystemFuncs(PermissionList), (permissionItem, index) => {
            return (
              <React.Fragment key={permissionFunc.getPermissionId(permissionItem)}>
                <TableRow id={`setting_row_${index}`}>
                  <TableCell align={aligns[0]} className={classes.underLine}>
                    <Typography style={{ fontSize: '1.25rem' }}>
                      {permissionFunc.getFuntionName(permissionItem)}
                    </Typography>
                  </TableCell>
                  <TableCell align={aligns[1]} className={classes.underLine} />
                </TableRow>
                {_.map(PermissionListFunc.orderAllActions(PermissionList), (actionPermi, actionIndex) => {
                  return (
                    permissionFunc.getParentId(actionPermi) === permissionFunc.getPermissionId(permissionItem) && (
                      <TableRow key={permissionFunc.getPermissionId(actionPermi)}>
                        <TableCell align={aligns[0]}>
                          <Typography>{permissionFunc.getFuntionName(actionPermi)}</Typography>
                        </TableCell>
                        <TableCell align={aligns[1]}>
                          <CkeckBox
                            id={`setting_checkbox_${index}`}
                            checked={Boolean(isPermissionList[actionIndex])}
                            onChange={onCheckBox(permissionFunc.getPermissionId(actionPermi))}
                            disabled={isSuperAdmin}
                          />
                        </TableCell>
                      </TableRow>
                    )
                  );
                })}
              </React.Fragment>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
